export default {
  enums: [
    { id: 'T1' },
    { id: 'T2' },
  ]
};